import { Trimestre } from './trimestre';
import { Aquisicao } from '../../../../cliente-carteira/kpis/aquisicao/adapters';
import { CarteiraInativa } from '../../../../cliente-carteira/kpis/carteira-inativa/adapters';
import { Comissao } from '../../../../comissao/kpis/adapters';

/** Dados dos KPIs semestral */
export class Semestre {
    semestre: number;
    trimestres: Trimestre[];
    aquisicao: Aquisicao;
    carteiraInativa: CarteiraInativa;
    comissao: Comissao;

    constructor(props: Partial<Semestre>) {
        Object.assign(this, props);

        if (props) {
            // Trimestres
            this.constructorTrimestres(props.trimestres);
            // Aquisição
            this.aquisicao = props.aquisicao ? new Aquisicao(props.aquisicao) : null;
            // Carteira Inativa
            this.carteiraInativa = props.carteiraInativa ? new CarteiraInativa(props.carteiraInativa) : null;
            // Comissão
            this.comissao = props.comissao ? new Comissao(props.comissao) : null;
        }
    }

    /** Constructor para os trimestres */
    private constructorTrimestres(trimestres: Trimestre[]) {
        if (trimestres && Array.isArray(trimestres)) {
            this.trimestres = trimestres.map(trimestre => new Trimestre(trimestre));
        } else {
            this.trimestres = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Semestre {
        return new Semestre(JSON.parse(json));
    }
}
